const selector = '.finite-scroll[data-finite-scroll-data]';
const trackSelector = '.Single[data-track-post-id-read]';
const footerSelector = '.Site__footer';
const scrollUrlSelector = '[data-scroll-url]';
const readPostsKey = 'read_posts';
let $container;
let $spinner;
let scrollUrls;
let $window;
let $footer;
let loading = false;
let loadedPostsCount = 0;
let scrollUrlTimeout;

function isPublic() {
  if (!window.mediaconnectParams) {
    return true;
  }
  if (!$(`.${window.mediaconnectParams.protectedContentClassName}:not(${window.mediaconnectParams.protectedContentClassName}--show)`).length) {
    return true;
  }
  return false;
}

function setup() {
  $footer.addClass('Site__footer--hidden');
  window.setTimeout(() => {
    setScrollUrls();
    $window.on('scroll', checkFiniteScroll);
    $window.on('resize', setScrollUrls);
    $window.on('scroll', checkScrollUrlDebounced);
    $window.on('popstate', checkPopState);
    $window.on('mediaconnect:paywall_was_shown', stopFiniteScroll);
  }, 200);
}

function setScrollUrls() {
  scrollUrls = [];
  $(scrollUrlSelector).each(function() {
    const $el = $(this);
    scrollUrls.push({
      top: $el.offset().top,
      url: $el.data('scroll-url'),
      title: $el.data('scroll-title'),
    });
  });
}

function checkFiniteScroll() {
  if (loading) {
    return;
  }
  if ($window.scrollTop() + $window.innerHeight() + 500 > document.body.clientHeight) {
    load();
  }
}

function checkScrollUrlDebounced() {
  window.clearTimeout(scrollUrlTimeout);
  scrollUrlTimeout = window.setTimeout(checkScrollUrl, 100);
}

function checkPopState() {
  const activeScrollUrl = scrollUrls.find(scrollUrl => window.document.location.href.indexOf(scrollUrl.url) > -1);
  if (activeScrollUrl) {
    $('html, body').animate({
      scrollTop: activeScrollUrl.top - 100,
    }, 500);
  }
}

function checkScrollUrl() {
  const scrollUrlsAboveFold = scrollUrls.filter(scrollUrl => scrollUrl.top < $window.scrollTop() + $window.innerHeight());
  if (!scrollUrlsAboveFold.length) {
    return;
  }
  const lastScrollUrlAboveFold = scrollUrlsAboveFold[scrollUrlsAboveFold.length - 1];
  // Replace state if last above fold is not active
  if (window.document.location.href.indexOf(lastScrollUrlAboveFold.url) === -1) {
    window.history.pushState({}, lastScrollUrlAboveFold.title, lastScrollUrlAboveFold.url);
  }
}

function load() {
  const url = window.fpgmedia_js_params ? window.fpgmedia_js_params.ajaxurl : '/wp-admin/admin-ajax.php';
  if (!url) {
    return;
  }
  startLoading();
  $.ajax({
    type: 'POST',
    url,
    data: {
      action: 'load_post',
      taxonomies: $container.data('finite-scroll-data'),
      loaded_posts_count: loadedPostsCount,
      read_post_ids: getReadPostIds(),
    },
    success: function(response) {
      if (response.data && response.data.html) {
        trackPostIsRead(response.data.post_id);
        const $postEl = $(response.data.html);
        $container.append($postEl);
        setScrollUrls();
        loadedPostsCount++;
        stopLoading();
        window.setTimeout(() => $window.trigger('fpgmedia:post_loaded', $postEl), 250);
        $window.trigger('mediaconnect:check_paywall', $postEl.get(0));
        return;
      }
      stopFiniteScroll();
    },
    error: function() {
      stopFiniteScroll();
    },
  });
}

function startLoading() {
  if (!$spinner) {
    $spinner = $('<div class="spinner"></div>');
    $container.append($spinner);
  }
  loading = true;
  $spinner.show();
}

function stopLoading() {
  $spinner.hide();
  window.setTimeout(() => {
    loading = false;
  }, 250);
}

function stopFiniteScroll() {
  $footer.removeClass('Site__footer--hidden');
  $window.off('scroll', checkFiniteScroll);
  stopLoading();
}

function trackPostIsRead(postId) {
  const readPostIds = getReadPostIds();
  if (readPostIds.indexOf(postId) === -1) {
    window.sessionStorage.setItem(readPostsKey, JSON.stringify([...readPostIds, postId]));
  }
}

function getReadPostIds() {
  return JSON.parse(window.sessionStorage.getItem(readPostsKey) || '[]');
}

export default function() {
  const $trackEl = $(trackSelector);
  if ($trackEl.length) {
    trackPostIsRead($trackEl.data('track-post-id-read'));
  }
  $container = $(selector);
  if ($container.length) {
    $window = $(window);
    $footer = $(footerSelector);
    if (isPublic()) {
      return setup();
    }
    $window.on('mediaconnect:paywall_was_hidden', setup);
  }
}



// WEBPACK FOOTER //
// ./scripts/components/finite-scroll.js